import { useRouter } from 'next/router'

import { IUL_LP_URL } from '@/constants'
import { useDecisionForFlag } from 'lib/FeaturesAndExperiments/getDecisionForFlag'

const REDIRECT_TO_NEW_IUL_FLOW_FEATURE = {
  name: 'redirect_to_iul_approval',
  VARIANTS: {
    off: 'off',
    IUL_APPROVAL: 'iul_approval',
  },
}

const NEW_FLOW = '/app/flow/iul-d2c-p2'

export const useRedirectToNewIULFlow = () => {
  const { asPath } = useRouter()

  const pathWithoutQuery = asPath.split('?')[0]
  const isIulPage = pathWithoutQuery.includes(IUL_LP_URL)

  const { variation } = useDecisionForFlag({
    name: REDIRECT_TO_NEW_IUL_FLOW_FEATURE.name,
    fallbackVariation: REDIRECT_TO_NEW_IUL_FLOW_FEATURE.VARIANTS.off,
    bypassActivate: !isIulPage,
  })

  const isIulApproval =
    variation === REDIRECT_TO_NEW_IUL_FLOW_FEATURE.VARIANTS.IUL_APPROVAL

  return {
    isRedirectToNewIULFlowEnabled: isIulApproval,
    newFlow: NEW_FLOW,
  }
}
